import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import { SwitchFilter } from '@/types/filters';

interface IFilterSwitchProps {
  config: SwitchFilter;
  value: boolean;
  onChange: (key: string, value: string) => void;
  className?: string;
}

export const DataTableSwitchFilter = ({
  config: { label, name },
  value,
  onChange,
  className,
}: IFilterSwitchProps) => {
  return (
    <div className={cn('align-center flex h-9 gap-2 rounded border px-2 py-1 text-sm', className)}>
      <div className="flex items-center justify-between gap-2">
        <Switch
          id="filter-switch"
          checked={value}
          onCheckedChange={val => onChange(name, val ? 'true' : '')}
        />
        <p>{label}</p>
      </div>
    </div>
  );
};
